/**
 * Meta (Facebook) Pixel helpers.
 *
 * The base pixel snippet + `fbq('init', ...)` lives in `public/index.html`, so
 * `window.fbq` is available globally once that script loads. These thin wrappers
 * guard against `fbq` being undefined (e.g. blocked by an ad blocker, or before
 * the snippet has executed) so callers never crash.
 *
 * Pixel ID: 1285160816719008 ("Police Narratives AI Web").
 */

/** Fire a SPA route-change PageView. The initial PageView is fired in index.html. */
export const trackPageView = (): void => {
  try {
    window.fbq?.("track", "PageView");
  } catch (e) {
    // Never let analytics break the app.
  }
};

/**
 * Fire the standard CompleteRegistration conversion. Call this exactly once,
 * only after a brand-new account has actually been created server-side
 * (email/password, Google, or Apple signup). This is the conversion the paid
 * ad campaign optimizes toward.
 */
export const trackCompleteRegistration = (): void => {
  try {
    window.fbq?.("track", "CompleteRegistration");
  } catch (e) {
    // no-op
  }
};

/** Fire the standard Subscribe conversion on a confirmed paid subscription. */
export const trackSubscribe = (value?: number, currency = "USD"): void => {
  try {
    const params =
      typeof value === "number" && !Number.isNaN(value)
        ? { value, currency }
        : undefined;
    window.fbq?.("track", "Subscribe", params);
  } catch (e) {
    // no-op
  }
};
